import React from "react";
import {
  StyleSheet,
  Text,
  TouchableNativeFeedback,
  TouchableOpacity,
  View,
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import { CrateV2, Delivered, PacketsV2 } from "@assets/svg/MyDeliveries";
import RightArrow from "@assets/svg/RightArrow";
import { colors } from "@constants/theme";
import t from "@constants/localization";
import analytics from "@services/analytics";
import { MY_DELIVERY_EVENTS } from "@constants/analyticsEventsCT";
import CratePacketItemsInfo from "../components/CratePacketItemsInfo";
import DeliveryBoyInfoComponent from "./DeliveryBoyInfoComponent";

const PATH = "screens/MyDeliveries/DeliveryReturn/DeliveryCard";

function SkuDeliveryCard({
  skuDelivery,
  setInfoTooltipVisible,
  setInfoTooltipData,
}) {
  const navigation = useNavigation();
  const deliveryState = skuDelivery?.state;
  const Content = [
    {
      field: "SKU",
      icon: <CrateV2 />,
      text: t(`${PATH}/sku`),
      value: skuDelivery?.noOfSkus || 0,
    },
    {
      field: "Qty",
      icon: <PacketsV2 />,
      text: t(`${PATH}/qty`),
      value: skuDelivery?.noOfItems || 0,
    },
  ];

  const handleCardPress = () => {
    navigation.navigate("SkuOrdersDetails", {
      order_ids: skuDelivery?.orders_list,
      title: skuDelivery?.title || t(`${PATH}/Delivery`),
    });
    analytics.trackEvent(MY_DELIVERY_EVENTS.VIEW_DETAILS_CLICKED, {
      screen: "Delivery Page",
      tab: "Current day",
      section: "SKU Deliveries",
    });
  };

  const onPressInfo = (data) => {
    setInfoTooltipVisible(true);
    setInfoTooltipData(data);
  };

  const deliveryOtp = skuDelivery?.delivery_otp;
  const deliveryOtpStatus = skuDelivery?.delivery_otp_status;

  const DeliveryOtpButton = () => {
    if (deliveryOtpStatus !== "GENERATED" || !deliveryOtp) return null;
    return (
      <TouchableOpacity testID="see_sku_delivery_otp">
        <View style={styles.otpContainer}>
          <Text style={styles.otpText}>
            {`${t(`${PATH}/deliveryOtp`)}: ${deliveryOtp}`}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <View style={styles.cardContainer}>
      <TouchableNativeFeedback
        testID="handleSkuDeliveryCardPress"
        background={TouchableNativeFeedback.Ripple("rgba(0, 0, 0, 0.05)")}
        onPress={handleCardPress}
      >
        <View style={styles.card}>
          <View
            style={[
              styles.headerContainer,
              {
                backgroundColor:
                  deliveryState === "Delivery"
                    ? "rgba(0, 171, 89, 0.04)"
                    : "rgba(0, 0, 0, 0.04)",
                flex: 1,
                justifyContent: "space-between",
              },
            ]}
          >
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Delivered status={deliveryState} />
              <Text
                style={
                  deliveryState === "Delivery"
                    ? styles.greenHeaderText
                    : styles.greyHeaderText
                }
              >
                {skuDelivery?.title || t(`${PATH}/${deliveryState}`)}
              </Text>
            </View>
            <DeliveryOtpButton />
          </View>
          {deliveryState === "Delivery" &&
          skuDelivery?.delivery_boy_info &&
          skuDelivery?.delivery_boy_info?.status === "ASSIGNED" ? (
            <DeliveryBoyInfoComponent
              deliveryBoyInfo={skuDelivery.delivery_boy_info}
            />
          ) : null}
          <CratePacketItemsInfo Content={Content} onPressInfo={onPressInfo} />
          <View style={styles.buttonStyle}>
            <View />
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Text style={styles.viewDetailsText}>
                {t(`${PATH}/viewDetails`)}
              </Text>
              <RightArrow
                stroke={colors.extraLightBlack}
                fill={colors.extraLightBlack}
              />
            </View>
          </View>
        </View>
      </TouchableNativeFeedback>
    </View>
  );
}

const styles = StyleSheet.create({
  cardContainer: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    marginTop: 8,
  },
  card: {
    backgroundColor: colors.white,
    borderWidth: 0.5,
    borderRadius: 10,
    elevation: 2,
    borderColor: colors.lighterBlack,
  },
  headerContainer: {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
    padding: 10,
    flexDirection: "row",
    alignItems: "center",
  },
  greenHeaderText: {
    fontSize: 12,
    fontFamily: "NotoSansDevanagari-Bold",
    lineHeight: 18,
    color: colors.plain_green,
    marginHorizontal: 4,
  },
  greyHeaderText: {
    fontSize: 12,
    fontFamily: "NotoSansDevanagari-Bold",
    lineHeight: 18,
    color: colors.lightBlack,
    alignItems: "center",
    marginHorizontal: 4,
  },
  buttonStyle: {
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 12,
    borderTopWidth: 0.8,
    borderColor: colors.lighterBlack,
    width: "100%",
  },
  viewDetailsText: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontSize: 14,
    lineHeight: 20,
    marginRight: 8,
  },
  otpContainer: {
    backgroundColor: colors.plain_green,
    paddingHorizontal: 10,
    borderRadius: 40,
    paddingVertical: 2,
  },
  otpText: {
    fontSize: 11,
    fontFamily: "NotoSansDevanagari-Bold",
    color: colors.white,
    lineHeight: 18,
  },
});

export default SkuDeliveryCard;
